<template>
    <div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div v-if="updatePrimaryAdminMsg" class="text-green">{{ updatePrimaryAdminMsg }}</div>
        <div class="row mt-4">
            <div class="col-12">
                <div class="overview-title">Address</div>
            </div>
            <div class="col-12">
                <div>{{ formatAddress(overview) }}</div>
                <div v-if="overview.phone_number"><i class="fa fa-phone overview-icons"></i> &nbsp; {{ overview.phone_number | formatOverviewPhoneNumber }}</div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <div class="overview-title">Primary Manager &nbsp; 
                    <a v-if="!readOnly" class="linkable branding_text_color" @click="openUpdatePrimaryManagerModal(overview)">Change</a>
                </div>
            </div>
            <div class="col-12" v-if="overview.primary_email">
                <div class="mb-1">{{ overview.primary_fname + ' ' + overview.primary_lname }}</div>
                <div><a class="mailto" :href="'mailto:' + overview.primary_email"><i class="fa fa-envelope-o overview-icons"></i> &nbsp; {{ overview.primary_email }}</a></div>
                <div class="mt-1" v-if="overview.primary_phone_number"><i class="fa fa-phone overview-icons"></i> &nbsp; {{ overview.primary_phone_number | formatOverviewPhoneNumber }}</div>
            </div>
            <div class="col-12" v-else>
                <div class="mb-1 text-red">No Primary Admin Found</div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <div class="license_panel_heading">
                    <div class="lheading_1 overview-title">License</div>
                    <div class="lheading_2" >
                        <a @click="openAddSubscriptionModal" class="linkable" style="color: #00ACEE !important;">Add {{ overview.subscriptionName }}</a>
                    </div>
                    <div class="clearfix"></div>
                    <div >
                        Active License: <b>{{ overview.activeLicense }}</b>
                    </div>
                        Used License: <b>{{ overview.usedLicense }}</b>
                    <div >
                    </div>
                </div>
            </div>
        </div>

        <UpdatePrimaryManagerModal
            :isUpdatePrimaryManagerModalVisible="isUpdatePrimaryManagerModalVisible"
            ref="update_primary_modal"
            :readOnly="readOnly"
            @close="closeUpdatePrimaryManagerModal"
        />

        <RenewAccountLicense
              :isRenewModalVisible="isRenewModalVisible" 
              :accountId="accountId"
              @close="closeRenewModal"
              ref="renew_account_license" 
             />

        <AddNewAccountLicense
              :isAddNewAccountLicenseModalVisible="isAddNewAccountLicenseModalVisible" 
              :accountId="accountId"
              @close="closeAddSubscriptionModal"
              ref="add_new_account_license" 
             />

    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import moment from 'moment';
import UpdatePrimaryManagerModal from './update_primary_manager_modal.vue';
import RenewAccountLicense from './renew_account_license.vue';
import AddNewAccountLicense from './add_new_account_license.vue';

Vue.filter('formatOverviewPhoneNumber', function(value) {
  if (value) {
    return value.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
});
Vue.filter('formatExpirationDate', function(value) {
    if (value) {
        return moment(String(value)).format('MMMM Do, YYYY')
    } else {
        return 'n/a';
    }
});

export default {
    props: ['accountId', 'readOnly'],
    data() {
        return {
            loading: false,
            overview: {
                phone_number: '',
                primary_admin_id: '',
                primary_fname: '',
                primary_lname: '',
                primary_email: '',
                primary_phone_number: '',
                subscriptionName: '',
                subscriptionPrice: '',
                subscriptionValidityDuration: '',
                expirationDate: '',
                primaryAdminRenew: '',
                renewFlag: 0,
                activeLicense: 0,
                usedLicense: 0,
            },
            isUpdatePrimaryManagerModalVisible: false,
            updatePrimaryAdminMsg: '',
            isRenewModalVisible: false,
            isAddNewAccountLicenseModalVisible: false,
        }
    },
    components: {
        UpdatePrimaryManagerModal,
        RenewAccountLicense,
        AddNewAccountLicense,
    },
    methods: {
        setOverview(account) {
            this.updatePrimaryAdminMsg = '';
            this.overview = account;
        },
        formatAddress(item) {
            var display_address = "";
            if (item.address) {
                display_address += item.address + ", ";
            }
            if (item.city) {
                display_address += item.city + ", ";
            }
            if (item.state) {
                display_address += item.state + ", ";
            }
            if (item.zip) {
                display_address += item.zip + ", ";
            }
            return display_address.slice(0, -2);
        },
        formatSubscriptionYear(no_of_years) {
            var display_year = "";
            if (no_of_years == 1) {
                display_year += "mo";
            } else {
                display_year += no_of_years + " mo";
            }
            return display_year;
        },
        openUpdatePrimaryManagerModal(overview) {
            this.isUpdatePrimaryManagerModalVisible = true;
            this.$refs.update_primary_modal.setUserInfo(overview);
            this.$refs.update_primary_modal.getAllAdmins(this.accountId);
        },
        closeUpdatePrimaryManagerModal() {
            this.isUpdatePrimaryManagerModalVisible = false;
        },
        reloadOverviewTab() {
            this.$parent.selectedComponent = 'OverviewTab';
            this.updatePrimaryAdminMsg = 'Primary Admin Updated Successfully';
            this.$parent.getLocationDetail(this.accountId);
        },
        openRenewModal() {
            this.isRenewModalVisible = true;
            this.accountId = this.accountId;
            this.$refs.renew_account_license.loadInitialData();
        },
        closeRenewModal() {
            this.isRenewModalVisible = false;
        },
        openAddSubscriptionModal() {
            this.isAddNewAccountLicenseModalVisible = true;
            this.$refs.add_new_account_license.loadInitialData();
        },
        closeAddSubscriptionModal() {
            this.isAddNewAccountLicenseModalVisible = false;
        }
    },
}
</script>
<style scoped>
.overview-title { font-weight: 900; margin-bottom: 10px; }
.overview-icons { color: #bfbfbf; font-size: 1rem; }
.linkable { text-decoration: underline !important; font-weight: 900; cursor:pointer; }
.hightlight { border-bottom: 1px solid #000; }
.text-red { color: #dc3545; font-weight: 900; }
.loading_show { height: auto; }
.text-green { color: #28a745 !important; font-weight: 900; }
.license_heading_1 { width: 35%; float: left; }
.license_heading_2 { width: 15%; float: left; }
.license_heading_3 { width: 40%; float: left; }
.license_heading_4 { width: 10%; float: left; }
.license_panel_heading { width: 100%; }
.lheading_1 { width: 75%; float: left; }
.lheading_2 { width: 25%; float: left; text-align: left; }
.mailto, .mailto:hover { text-decoration: none; color: #00acee; font-weight: bold; }
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/overview_tab.vue